<template>
  <FormContainer class="register__account-type-form__form-container">
    <div class="account-type-form__text-block">
      <h2 class="account-type-form__title">Вітаю в UConnect</h2>
      <p class="account-type-form__description">Ми надійна CRM-платформа для агентів і партнерських мереж</p>
    </div>
    <StatusProgress
      class="account-type-form__progress"
      :current-step="getCurrentStep"
    />
    <AccountTypeSelector
      class="account-type-form__account-type-selector"
      ref="accountSelector"
      :account-type="getAccountType"
      @update-account-type="updateAccountType"
    />
    <div class="account-type-form__next-step">
      <OrangeFancyButton
        class="account-type-form__next-step--button"
        type="submit"
        :disabled="!getAccountType"
        @click="switchCurrentStep"
      >
        Далі
      </OrangeFancyButton>
    </div>
    <div class="account-type-form__login">
      <p class="account-type-form__login-text">
        У вас вже є аккаунт?
        <SmartLink
          class="account-type-form__link--login"
          :route="{ name: 'login' }"
        >
          Увійти
        </SmartLink>
      </p>
    </div>
  </FormContainer>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import StatusProgress from '../status-progress';
import AccountTypeSelector from './account-type-selector';
import { FormContainer } from '@/shared/ui/account';
import { OrangeFancyButton } from '@/shared/ui/form';
import { SmartLink } from '@/shared/ui/link';

export default {
  components: { SmartLink, OrangeFancyButton, FormContainer, StatusProgress, AccountTypeSelector },
  computed: {
    ...mapGetters('registerModule', ['getCurrentStep', 'getAccountType']),
  },
  methods: {
    ...mapActions('registerModule', ['setAccountType', 'switchCurrentStep']),
    updateAccountType(type) {
      this.setAccountType(type);
    },
  },
};
</script>

<style lang="scss" scoped>
.register__account-type-form {
  &__form-container {
    margin: 170px auto 0;
    width: 600px;

    @media (max-width: 630px) {
      margin: 50px 16px 0;
      width: auto;
    }
  }
}

.account-type-form {
  &__title {
    font-family: "IBM Plex Sans", sans-serif;
    font-size: 36px;
    font-weight: 400;
    color: #0C1421;
    text-align: center;
    margin-bottom: 16px;

    @media (max-width: 630px) {
      font-size: 24px;
    }
  }

  &__description {
    font-size: 18px;
    font-weight: 400;
    color: #313957;
    text-align: center;

    @media (max-width: 630px) {
      font-size: 14px;
    }
  }

  &__progress {
    margin-bottom: 16px;
  }

  &__account-type-selector {
    margin-bottom: 32px;
  }

  &__next-step {
    margin-bottom: 32px;
  }

  &__login {
    text-align: center;
  }

  &__link {
    &--login {
      font-family: 'Inter', sans-serif;
      font-size: 16px;
      font-weight: 400;
      color: #6171E4;

      &:hover {
        text-decoration: underline;
      }
    }
  }
}
</style>
